import { combineReducers } from 'redux';
import { APIReducer } from 'store/apiReducer';
import {
    CONTEXT_GET_NOMBRE_NOTIFICATIONS,
    CONTEXT_GET_NOTIFICATIONS,
} from '../../constants/apiUrls.constants';

const notification = combineReducers({
    nombreNotificationsUsager: APIReducer.bind(null, CONTEXT_GET_NOMBRE_NOTIFICATIONS),
    notificationsUsager: APIReducer.bind(null, CONTEXT_GET_NOTIFICATIONS),
});

export default notification;
